"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderLoader = exports.renderComponent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const webexUI_1 = require("webexUI");
const ModalDialog_1 = require("Views/Partials/Components/ModalDialog");
const SignUpFormStatusMessage_1 = require("Views/Partials/Components/SignUp/components/SignUpFormStatusMessage");
const Newsletter_1 = require("./components/Newsletter");
exports.renderComponent = {
    Form: (signUpTypes, apiUrl, hashMapTypes, reCaptchaSiteKey, bypassRecaptchaKey, render, control, pageId) => ((0, jsx_runtime_1.jsx)(Newsletter_1.NewsletterForm, { items: signUpTypes.formItems, inputObject: signUpTypes.inputObject, pageId: pageId, apiUrl: apiUrl, renderSpinner: render.renderSpinner, renderMessage: render.renderMessage, control: control, additionalFormData: hashMapTypes.additionalFormData, reCaptchaSiteKey: reCaptchaSiteKey, bypassRecaptchaKey: bypassRecaptchaKey })),
    Message: (message, buttonLabel) => ((0, jsx_runtime_1.jsx)(SignUpFormStatusMessage_1.SignUpFormStatusMessage, { message: message, buttonLabel: buttonLabel, close: close })),
    Spinner: (0, jsx_runtime_1.jsx)(webexUI_1.Spinner, { visible: true }),
};
const renderLoader = (component, selector, title, classes, popupAriaLabel, closeButtonAriaLabel, onModalClose) => {
    const additionalModalParameters = {
        classes,
        onModalClose,
        popupAriaLabel,
        closeButtonAriaLabel,
        backdrop: 'static',
    };
    (0, ModalDialog_1.RenderModal)(component, selector, title, additionalModalParameters);
};
exports.renderLoader = renderLoader;
